import { createContext } from "react";

export interface ChatContextProps {
  /** Opens the live‑chat window for a specific topic */
  openChat: (topic: string) => void;
}

export const ChatContext = createContext<ChatContextProps>({
  openChat: (topic: string): void => {
    // default (no‑op) implementation for the context’s initial value
    void topic; // prevents “unused parameter” lint error
  },
});
